import React from 'react'
import {Spin} from 'antd'

function Spinner () {
  return <div data-testid='loading-spinner' style={{textAlign: 'center', marginTop: 300}}><Spin /></div>
}
export default Spinner
